export default {
  data() {
    return {
      isMobile:true,
    }
  },
  mounted(){
    this._isMobile()
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile= flag?true:false;
      return flag;

    },
  }
}
